import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || "";

export const initAnalytics = () => {
  mixpanel.init(MIXPANEL_TOKEN, {
    // api_host: "/mp",
    debug: true,
    persistence: "localStorage",
  });
};

export const trackLandingPageView = () => {
  mixpanel.track("Landing Page View", {
    referrer: document.referrer || "direct",
    url: window.location.href,
  });
};

export const trackAppDownloadClick = (
  store: "app_store" | "play_store",
  appType: "stylist" | "client",
) => {
  mixpanel.track("App Download Click", {
    store,
    app_type: appType,
    user_agent: navigator.userAgent,
  });
};

export const trackFindProfessionalClick = () => {
  mixpanel.track("Find Beauty Professional Click", {
    user_agent: navigator.userAgent,
  });
};
